import React from "react";
import { DiffModeOption } from "types/WorkbookDiff";
import { useDiffMode, useSetDiffMode } from "../DiffProvider";
import classNames from "classnames";

const DiffMode = ({
  options,
  className,
}: {
  options: DiffModeOption[];
  className?: string;
}) => {
  const mode = useDiffMode();
  const setMode = useSetDiffMode();

  return (
    <div className={classNames("flex items-center py-2", className)}>
      <div className="bg-gray-100 inline-flex h-9 w-fit items-center justify-center rounded-lg p-2 gap-1 relative overflow-visible">
        {options.map((option: DiffModeOption) => (
          <button
            key={option.value}
            onClick={() => setMode(option.value)}
            className={classNames(
              "inline-flex h-full flex-1 items-center justify-center rounded-md border border-transparent p-3 text-sm font-medium whitespace-nowrap transition-colors relative",
              mode === option.value
                ? "bg-white text-black shadow-sm"
                : "text-black hover:bg-gray-50",
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DiffMode;
